/*LIBRARY MODULE*/
import { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

/*PERSONAL COMPONENT*/
import UploadKTP from "../form/UploadKTP";
import Modal from "../common/Modal";
import Login from "../auth/Login";
import Title from "../form/Title";
import BlogRead from "../form/BlogRead";

/*REDUX FUNCTION*/
import {
  get_feature,
  getFieldsPrivate,
  getDocForm,
  applyForm,
} from "../../actions/formActions";
import {
  updateFullname,
  updateCity,
  updatePhone,
} from "../../actions/authActions";
import { set_value_properties } from "../../actions/propertiesActions";

/*PICTURE ASSET*/
import icon_check from "../../img/icon_check.svg";
import icon_uncheck from "../../img/icon_uncheck.svg";

/*GENERAL*/
import dict from "../../validation/dict.json";
import ProvinsiKabupaten from "../common/ProvinsiKabupaten.json";
import history from "../../actions/history";
import Kabupaten from "../common/Kabupaten.json";

const cities_array = Kabupaten.sort();

const Step1 = ({
  auth: {
    user,
    isAuthenticated,
    isRegistered,
    loadingProcess: loadingProcessUser,
    itemLoading: itemLoadingUser,
  },
  form: { loading, itemLoading, geo_layer_wo_geojson, error },
  match: { params },
  get_feature,
  getFieldsPrivate,
  getDocForm,
  applyForm,
  updateFullname,
  updateCity,
  updatePhone,
  set_value_properties,
}) => {
  const [cities_filtered, set_cities_filtered] = useState(cities_array);
  const [full_name, set_full_name] = useState(user?.full_name || "");
  const [city, set_city] = useState(user?.city || "");
  const [phone_number_state, set_phone_number_state] = useState(
    user?.phone_number || "62",
  );

  const [modalUserData, set_modalUserData] = useState(false);
  const [modalApplyPaidSurvey, set_modalApplyPaidSurvey] = useState(false);
  const [amount, set_amount] = useState(0);
  const [modalEditName, set_modalEditName] = useState(false);
  const [modalEditCity, set_modalEditCity] = useState(false);
  const [modalEditPhone, set_modalEditPhone] = useState(false);

  const [readStatus, set_readStatus] = useState(false);
  const [modalLogin, set_modalLogin] = useState(false);

  const link = params?.link;
  const feature_key = params?.feature_key || "";

  const redirect_step_2 = useCallback(() => {
    history.push(`/${link || ""}/step_2/${feature_key}`);
  }, [link, feature_key]);

  const on_start = useCallback(() => {
    const status = geo_layer_wo_geojson?.formStatus?.status;
    const is_form_login_req = geo_layer_wo_geojson?.is_form_login_req;

    // Prioritize login requirement even if form is public/data is loaded
    if (is_form_login_req && !isAuthenticated) {
      return;
    }

    //handle jika itu bukan form paid, maka langsung redirect ke step 2 (peta)
    if (status === "not_propose") {
      redirect_step_2();
    }
  }, [
    geo_layer_wo_geojson?.formStatus?.status,
    geo_layer_wo_geojson?.is_form_login_req,
    isAuthenticated,
    redirect_step_2,
  ]);

  useEffect(() => {
    set_full_name(user?.full_name || "");
    set_city(user?.city || "");
    set_phone_number_state(user?.phone_number || "62");

    //keperluan data pembanding
    const search = window?.location?.search?.substring(1);
    let object_param = {};
    let apraisal_id;
    if (search) {
      try {
        object_param = JSON.parse(
          '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
          function (key, value) {
            return key === "" ? value : decodeURIComponent(value);
          },
        );
        apraisal_id = object_param?.apraisal_id;
      } catch (err) {
        // ignore JSON parse error
      }
    }

    if (feature_key) {
      const payload = {
        geo_layer_link: link,
        feature_key,
        apraisal_id,
        step: "step_1",
      };
      get_feature(payload);
      set_value_properties({
        key: "feature_key",
        value: feature_key,
      });
    } else {
      const payload = {
        geo_layer_link: link,
        apraisal_id,
      };
      getFieldsPrivate(payload);
    }
    on_start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (geo_layer_wo_geojson?._id) {
      on_start();
    }
  }, [geo_layer_wo_geojson?._id, on_start]);

  useEffect(() => {
    if (isAuthenticated) {
      set_full_name(user?.full_name || "");
      set_city(user?.city || "");
      set_phone_number_state(user?.phone_number || "62");

      const search = window?.location?.search?.substring(1);
      let object_param = {};
      let apraisal_id;
      if (search) {
        try {
          object_param = JSON.parse(
            '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
            function (key, value) {
              return key === "" ? value : decodeURIComponent(value);
            },
          );
          apraisal_id = object_param?.apraisal_id;
        } catch (err) {
          // ignore
        }
      }

      if (feature_key) {
        const payload = {
          geo_layer_link: link,
          feature_key,
          step: "step_1",
        };
        get_feature(payload);
      } else {
        const payload = {
          geo_layer_link: link,
          apraisal_id,
        };
        getFieldsPrivate(payload);
      }
      on_start();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    const name = e.target.name;

    if (name === "city") {
      if (!value) {
        set_city(value);
        set_cities_filtered(cities_array);
      } else {
        const filtered = cities_array.filter((c) =>
          c.toLowerCase().includes(value.toLowerCase()),
        );
        set_city(value);
        set_cities_filtered(filtered);
      }
    } else if (name === "full_name") {
      set_full_name(value);
    } else if (name === "phone_number_state") {
      set_phone_number_state(value);
    } else if (name === "amount") {
      set_amount(value);
    }
  };

  const toggleUserData = () => set_modalUserData((prev) => !prev);
  const toggleApplyPaidSurvey = () => set_modalApplyPaidSurvey((prev) => !prev);
  const toggleEditName = () => set_modalEditName((prev) => !prev);
  const toggleEditCity = () => set_modalEditCity((prev) => !prev);
  const toggleEditPhone = () => set_modalEditPhone((prev) => !prev);
  const toggleLogin = () => set_modalLogin((prev) => !prev);

  const handleApplyPaidSurvey = (e) => {
    e.preventDefault();
    const body = {
      user: user?._id,
      geo_layer_id: geo_layer_wo_geojson?._id,
      amount: parseInt(amount, 10),
    };
    applyForm(body);
    set_modalApplyPaidSurvey(false);
  };

  const onClickCity = (selectedCity) => {
    set_city(selectedCity);
  };

  const handleFixCity = () => {
    if (cities_filtered.length === 0) {
      set_cities_filtered(cities_array);
    } else if (!cities_filtered.includes(city)) {
      set_city(cities_filtered[0] ? cities_filtered[0] : "");
    }
  };

  const handleFalseModalRead = () => {
    set_readStatus(true);
    setTimeout(() => {
      const el = document.getElementById("read_content");
      if (el) el.style.bottom = "-100vh";
    }, 0);
  };

  const handleUpdateFullname = (e) => {
    e.preventDefault();
    updateFullname({ full_name });
  };

  const handleUpdatePhone = (e) => {
    e.preventDefault();
    updatePhone({ phone_number: phone_number_state });
  };

  const handleUpdateCity = (e) => {
    e.preventDefault();
    if (!cities_filtered.includes(city)) {
      updateCity({ city: cities_filtered[0] ? cities_filtered[0] : "" });
    } else {
      updateCity({ city });
    }
  };

  const handleAddScreenStatus = () => {
    redirect_step_2();
  };

  const language = localStorage?.language ? localStorage?.language : "ina";

  const user_id = user?._id;
  const status = geo_layer_wo_geojson?.formStatus?.status;
  const api_status = geo_layer_wo_geojson?.api_status;
  const is_form_login_req = geo_layer_wo_geojson?.is_form_login_req;
  const features = geo_layer_wo_geojson?.geojson?.features || [];
  const features_length = features.length;

  const surveyors = geo_layer_wo_geojson?.formPayment?.surveyors || [];
  const surveyors_id = surveyors.map((surveyor) => String(surveyor?.user));

  const full_name_prop = user?.full_name;
  const city_prop = user?.city;
  const phone_prop = user?.phone_number;
  const ktp = user?.ktp;

  const auth_point = isAuthenticated ? 1 : 0;
  const full_name_point = full_name_prop ? 1 : 0;
  const phone_number_point = phone_prop ? 1 : 0;
  const city_point = city_prop ? 1 : 0;
  const ktp_point = ktp ? 1 : 0;

  const isCity = geo_layer_wo_geojson?.formPayment?.isCity;
  const isProvince = geo_layer_wo_geojson?.formPayment?.isProvince;
  const cities = geo_layer_wo_geojson?.formPayment?.cities || [];
  const provinces = geo_layer_wo_geojson?.formPayment?.provinces || [];
  let cities_final = [];

  const cities_province = provinces
    .map((province) => {
      return ProvinsiKabupaten[province] || [];
    })
    .flat();

  if (isProvince && provinces.length > 0) {
    cities_final = [...cities, ...cities_province];
  }

  let city_match_point = 0;

  const logic_1 = !isCity && !isProvince;
  const logic_2 = isCity && cities.includes(city_prop);
  const logic_3 = isProvince && cities_province.includes(city_prop);
  const logic_4 = isCity && isProvince && cities_final.includes(city_prop);

  if (logic_1 || logic_2 || logic_3 || logic_4) {
    city_match_point = 1;
  }

  const total_point =
    auth_point +
    full_name_point +
    city_point +
    ktp_point +
    phone_number_point +
    city_match_point;

  const percentage_point = (total_point / 6) * 100;

  const amount_props =
    geo_layer_wo_geojson?.formPayment?.surveyors?.[0]?.amount;
  const percentage = parseInt((features_length / amount_props) * 100, 10);

  let button_paid_mode;

  if (
    [
      "propose",
      "rejected",
      "recruit",
      "close_recruit",
      "wait_purchase",
      "user_purchase",
    ].includes(status)
  ) {
    if (surveyors_id.includes(user_id)) {
      button_paid_mode = (
        <div style={{ textAlign: "center" }}>
          <div className="text_medium" style={{ margin: "auto" }}>
            <Link
              className="button_standard"
              to={`/${geo_layer_wo_geojson?.link}/step_2/${feature_key}`}
            >
              {dict?.["Mulai Survei Berbayar"]?.[language]}
            </Link>
          </div>
        </div>
      );
    } else if (percentage_point === 100) {
      button_paid_mode = (
        <div style={{ textAlign: "center" }}>
          <div onClick={toggleApplyPaidSurvey} className="button_standard">
            {dict?.["Daftar Jadi Surveyor"]?.[language]}
          </div>
        </div>
      );
    } else {
      button_paid_mode = (
        <div style={{ textAlign: "center" }}>
          <div className="button_standard" id="grey">
            {dict?.["Daftar Jadi Surveyor"]?.[language]}
          </div>
          <div className="text_medium" style={{ margin: "auto" }}>
            {
              dict?.["Tombol akan aktif setelah semua pra-syarat terpenuhi"]?.[
                language
              ]
            }
          </div>
        </div>
      );
    }
  } else if (
    [
      "success_payment",
      "rejected_payment",
      "validation",
      "post_payment",
      "finish",
    ].includes(status) &&
    surveyors_id.includes(user_id)
  ) {
    button_paid_mode = (
      <div
        style={{ textAlign: "center" }}
        className="container_light"
        id="white_background"
      >
        <div
          style={{
            height: "10px",
            backgroundColor: "#dedede",
            borderRadius: "2rem",
            padding: "3px",
            margin: "auto",
            width: "80%",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${percentage > 100 ? 100 : percentage}%`,
              backgroundColor: "#7cc735ff",
              borderRadius: "2rem",
            }}
          />
        </div>
        <div
          className="text_medium"
          style={{ marginTop: "5px", marginBottom: "30px" }}
        >
          {dict?.["Kamu sudah isi"]?.[language]} {features.length}{" "}
          {dict?.["dari"]?.[language]} {amount_props}
          <br />
          {
            dict?.[
              "Jika kamu mengisi lebih dari target kamu ada kemungkinan ada data yang ditolak"
            ]?.[language]
          }
        </div>
        <div onClick={handleAddScreenStatus} className="button_standard">
          {dict?.["Mulai Survei Berbayar"]?.[language]}
        </div>
      </div>
    );
  }

  const paid_mode = (
    <main>
      <section className="container_light margin_bottom" id="white_background">
        {
          dict?.[
            "Untuk mengikuti survei berbayar ada beberapa pra-syarat untuk dipenuhi"
          ]?.[language]
        }
      </section>
      {!isAuthenticated && (
        <main className="container_light" id="white_background">
          <main className="two_container_icon_right">
            <section>
              <div className="text_bold">Log in</div>
              <div className="text_medium">
                {
                  dict?.[
                    "Silahkan log in atau mendaftar jika belum memiliki akun"
                  ]?.[language]
                }
              </div>
              {!isAuthenticated && (
                <div className="button_tight" onClick={toggleLogin}>
                  Log in
                </div>
              )}
            </section>
            <section style={{ textAlign: "right" }}>
              {isAuthenticated ? (
                <img src={icon_check} width="30px" alt="check" />
              ) : (
                <img src={icon_uncheck} width="30px" alt="check" />
              )}
            </section>
          </main>
        </main>
      )}
      {isAuthenticated && (
        <div>
          {!!(full_name_point && city_point && ktp_point) && (
            <div
              onClick={toggleUserData}
              className="button_standard margin_bottom"
            >
              {modalUserData
                ? dict?.["Tutup Data Pengguna"]?.[language]
                : dict?.["Buka Data Pengguna"]?.[language]}
            </div>
          )}
          {(modalUserData || !(full_name_point && city_point && ktp_point)) && (
            <main>
              <section
                className="container_light margin_bottom"
                id="white_background"
              >
                <div className="two_container_icon_right">
                  <div>
                    <p className="text_bold">
                      {dict?.["Nama lengkap"]?.[language]}
                    </p>
                    <p className="text_medium">
                      {
                        dict?.[
                          "Lengkapi akun kamu dengan nama lengkap sesuai yang tercantum di KTP"
                        ]?.[language]
                      }
                    </p>
                    <section className="text_bold">
                      {full_name_prop ? full_name_prop : "Belum diisi"}{" "}
                      <button onClick={toggleEditName} className="button_tight">
                        {dict?.["Edit nama lengkap"]?.[language]}
                      </button>
                    </section>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {full_name_prop ? (
                      <img src={icon_check} width="30px" alt="check" />
                    ) : (
                      <img src={icon_uncheck} width="30px" alt="check" />
                    )}
                  </div>
                </div>
              </section>

              <section
                className="container_light margin_bottom"
                id="white_background"
              >
                <div className="two_container_icon_right">
                  <div>
                    <p className="text_bold">
                      {dict?.["Kota Tinggal"]?.[language]}
                    </p>
                    <p className="text_medium">
                      {
                        dict?.[
                          "Lengkapi akun kamu dengan kota tempat tinggal kamu sekarang"
                        ]?.[language]
                      }
                    </p>
                    <section className="text_bold">
                      {city_prop ? city_prop : "Belum diisi"}{" "}
                      <button onClick={toggleEditCity} className="button_tight">
                        {dict?.["Edit tempat tinggal"]?.[language]}
                      </button>
                    </section>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {city_prop ? (
                      <img src={icon_check} width="30px" alt="check" />
                    ) : (
                      <img src={icon_uncheck} width="30px" alt="check" />
                    )}
                  </div>
                </div>
              </section>

              <section
                className="container_light margin_bottom"
                id="white_background"
              >
                <div className="two_container_icon_right">
                  <div>
                    <p className="text_bold">
                      {dict?.["Nomor Handphone"]?.[language]}
                    </p>
                    <p className="text_medium">
                      {
                        dict?.["Lengkapi akun kamu dengan nomor handphone"]?.[
                          language
                        ]
                      }
                    </p>
                    <section className="text_bold">
                      {phone_prop ? phone_prop : "Belum diisi"}{" "}
                      <button
                        onClick={toggleEditPhone}
                        className="button_tight"
                      >
                        {dict?.["Edit nomor handphone"]?.[language]}
                      </button>
                    </section>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {phone_prop ? (
                      <img src={icon_check} width="30px" alt="check" />
                    ) : (
                      <img src={icon_uncheck} width="30px" alt="check" />
                    )}
                  </div>
                </div>
              </section>

              <section
                className="container_light margin_bottom"
                id="white_background"
              >
                <div className="two_container_icon_right">
                  <div>
                    <div className="text_bold">
                      {dict?.["Upload KTP"]?.[language]}
                    </div>
                    <div className="text_medium">
                      {
                        dict?.[
                          "Upload foto KTP kamu sesuai dengan contoh di bawah"
                        ]?.[language]
                      }
                    </div>
                    <div
                      className="button_tight"
                      style={{ marginBottom: "7px" }}
                    >
                      {dict?.["Contoh"]?.[language]}
                    </div>
                    <UploadKTP />
                    {ktp && <img src={ktp} width="100px" alt="ktp" />}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {ktp ? (
                      <img src={icon_check} width="30px" alt="check" />
                    ) : (
                      <img src={icon_uncheck} width="30px" alt="check" />
                    )}
                  </div>
                </div>
              </section>
            </main>
          )}

          {(isCity || isProvince) && (
            <section
              className="container_light margin_bottom"
              id="white_background"
            >
              <div className="two_container_icon_right">
                <div>
                  <div className="text_bold">
                    {dict?.["Wilayah Survei"]?.[language]}
                  </div>
                  <div>
                    {
                      dict?.[
                        "Survei ini terbatas untuk kota/provinsi berikut"
                      ]?.[language]
                    }
                  </div>
                  {isCity &&
                    cities.map((cityParam, idx) => {
                      return (
                        <div key={idx} className="badge_normal" id="comfort">
                          {cityParam}
                        </div>
                      );
                    })}
                  {isProvince &&
                    provinces.map((province, idx) => {
                      return (
                        <div key={idx} className="badge_normal" id="comfort">
                          {province}
                        </div>
                      );
                    })}
                  <div style={{ marginTop: "20px" }}>
                    {dict?.["Kota tempat kamu tinggal sekarang"]?.[language]}:
                  </div>
                  <div className="badge_normal" id="comfort">
                    {city_prop}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  {city_match_point ? (
                    <img src={icon_check} width="30px" alt="check" />
                  ) : (
                    <img src={icon_uncheck} width="30px" alt="check" />
                  )}
                </div>
              </div>
            </section>
          )}

          <section
            className="container_light margin_bottom"
            id="white_background"
          >
            <div className="two_container_icon_right">
              <div>
                <div className="text_bold">
                  {dict?.["Baca Instruksi Survei"]?.[language]}
                </div>
                <div className="text_medium">
                  {
                    dict?.[
                      "Baca petunjuk pengisian survei ini untuk menambah potensi data survei kamu diterima"
                    ]?.[language]
                  }
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                {readStatus ? (
                  <img src={icon_check} width="30px" alt="check" />
                ) : (
                  <img src={icon_uncheck} width="30px" alt="check" />
                )}
              </div>
            </div>
          </section>
        </div>
      )}
      {button_paid_mode}
    </main>
  );

  let content;
  const isBackendError =
    error ||
    api_status === "layer_not_found" ||
    api_status === "memang tidak diperbolehkan untuk mengakses form" ||
    (!loading &&
      !geo_layer_wo_geojson?._id &&
      itemLoading !== "getFieldsPrivate" &&
      itemLoading !== "get_feature");

  if (
    loading &&
    (itemLoading === "getFieldsPrivate" || itemLoading === "get_feature")
  ) {
    content = (
      <main
        className="container_light"
        id="white_background"
        style={{ textAlign: "center", padding: "40px 20px" }}
      >
        Loading...
      </main>
    );
  } else if (isBackendError) {
    content = (
      <main
        className="container_light"
        id="white_background"
        style={{ textAlign: "center", padding: "40px 20px" }}
      >
        <h2 className="text_big" style={{ marginBottom: "15px" }}>
          Akses Ditolak / Form Tidak Ditemukan
        </h2>
        <p
          className="text_medium margin_bottom"
          style={{ maxWidth: "400px", margin: "0 auto 25px auto" }}
        >
          {dict?.[
            "Form tidak bisa dimuat. Ada kemungkinan form bersifat privat, Anda tidak memiliki akses, atau tautan salah."
          ]?.[language] ||
            "Form tidak bisa dimuat. Ada kemungkinan form bersifat privat, Anda tidak memiliki akses, atau tautan salah."}
        </p>
        <Link to="/menu/dashboard" className="button_standard">
          {dict?.["Kembali ke Beranda"]?.[language] || "Kembali ke Beranda"}
        </Link>
      </main>
    );
  } else if (is_form_login_req && !isAuthenticated) {
    content = (
      <main>
        <main className="container_light" id="white_background">
          <main className="two_container_icon_right">
            <section>
              <div className="text_bold">Log in</div>
              <div className="text_medium">
                {
                  dict?.["Survei ini mengharuskan kamu untuk masuk akun."]?.[
                    language
                  ]
                }
              </div>
              <div className="button_tight" onClick={toggleLogin}>
                Log in
              </div>
            </section>
            <section style={{ textAlign: "right" }}>
              <img src={icon_uncheck} width="30px" alt="check" />
            </section>
          </main>
        </main>
      </main>
    );
  } else if (
    [
      "propose",
      "rejected",
      "recruit",
      "close_recruit",
      "wait_purchase",
      "user_purchase",
      "success_payment",
      "rejected_payment",
      "validation",
      "post_payment",
      "finish",
    ].includes(status)
  ) {
    content = paid_mode;
  } else {
    content = <></>;
  }

  const modalLoginContent = modalLogin && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalLogin}
      onClose={toggleLogin}
    >
      <div className="box-body">
        <Login isNav={true} />
      </div>
    </Modal>
  );

  const modalEditNameContent = modalEditName && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalEditName}
      onClose={toggleEditName}
    >
      <div className="box-body">
        <form onSubmit={handleUpdateFullname}>
          <input
            name="full_name"
            id="full_name"
            type="text"
            value={full_name}
            onChange={handleChange}
          />
          <div style={{ textAlign: "center" }}>
            {loadingProcessUser && itemLoadingUser === "full_name" ? (
              <div className="button_standard">
                {dict?.["Menyimpan"]?.[language]}...
              </div>
            ) : (
              <button className="button_standard" type="submit">
                {dict?.["Simpan nama lengkap"]?.[language]}
              </button>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );

  const modalEditCityContent = modalEditCity && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalEditCity}
      onClose={toggleEditCity}
    >
      <div className="box-body">
        <form onSubmit={handleUpdateCity}>
          <div
            style={{
              borderRadius: "10px",
              border: "1px solid #d8d8d8",
              padding: "15px",
              marginBottom: "20px",
            }}
          >
            <input
              name="city"
              id="city"
              type="text"
              value={city}
              onChange={handleChange}
              onBlur={handleFixCity}
            />
            <div
              style={{
                height: "50vh",
                overflowY: "scroll",
                marginTop: "20px",
              }}
            >
              {cities_filtered.map((city_element, idx) => {
                return (
                  <div
                    onClick={() => onClickCity(city_element)}
                    key={idx}
                    className="text_medium"
                    style={{
                      marginBottom: "20px",
                      borderBottom: "1px solid #d8d8d8",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      paddingBottom: "10px",
                      height: "30px",
                    }}
                  >
                    {city_element}
                    {city_element === city && (
                      <img
                        src={icon_check}
                        width="25px"
                        alt="check"
                        style={{ marginLeft: "10px" }}
                      />
                    )}
                    {!cities_filtered.includes(city) && idx === 0 && (
                      <img
                        src={icon_check}
                        width="25px"
                        alt="check"
                        style={{ marginLeft: "10px" }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            {loadingProcessUser && itemLoadingUser === "updateCity" ? (
              <div className="button_standard">
                {dict?.["Menyimpan"]?.[language]}.........
              </div>
            ) : cities_filtered.length === 0 ? (
              <div className="button_standard" id="grey">
                {dict?.["Simpan tempat tinggal"]?.[language]}
              </div>
            ) : (
              <button className="button_standard" type="submit">
                {dict?.["Simpan tempat tinggal"]?.[language]}
              </button>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );

  const modalEditPhoneContent = modalEditPhone && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalEditPhone}
      onClose={toggleEditPhone}
    >
      <div className="box-body">
        <form onSubmit={handleUpdatePhone}>
          <input
            name="phone_number_state"
            id="phone_number_state"
            type="text"
            value={phone_number_state}
            onChange={handleChange}
          />
          <div style={{ textAlign: "center" }}>
            {loadingProcessUser && itemLoadingUser === "updatePhone" ? (
              <div className="button_standard">
                {dict?.["Menyimpan"]?.[language]}......
              </div>
            ) : (
              <button className="button_standard" type="submit">
                {dict?.["Simpan nomor handphone"]?.[language]}
              </button>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );

  const modalApplyPaidSurveyContent = modalApplyPaidSurvey && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalApplyPaidSurvey}
      onClose={toggleApplyPaidSurvey}
    >
      <main className="box-body">
        <div className="text_bold">
          {dict?.["Berapa target responden yang akan kamu survei?"]?.[language]}{" "}
          Minimum {geo_layer_wo_geojson?.formPayment?.minResponden || 0},{" "}
          {dict?.["maksimum"]?.[language]}{" "}
          {geo_layer_wo_geojson?.formPayment?.maxResponden || 0}
        </div>
        <form onSubmit={handleApplyPaidSurvey}>
          <input
            name="amount"
            id="amount"
            value={amount}
            type="range"
            min={geo_layer_wo_geojson?.formPayment?.minResponden || 0}
            max={geo_layer_wo_geojson?.formPayment?.maxResponden || 0}
            onChange={handleChange}
          />
          <section className="three_container">
            <div style={{ textAlign: "left" }}>
              <div
                className="badge_normal"
                style={{ fontSize: "16px", color: "#52606eff" }}
              >
                {geo_layer_wo_geojson?.formPayment?.minResponden || 0}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div
                className="badge_normal"
                style={{ fontSize: "16px", color: "#52606eff" }}
              >
                {amount
                  ? amount
                  : dict?.["Belum diisi, geser slider untuk mengisi"]?.[
                      language
                    ]}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div
                className="badge_normal"
                style={{ fontSize: "16px", color: "#52606eff" }}
              >
                {geo_layer_wo_geojson?.formPayment?.maxResponden || 0}
              </div>
            </div>
          </section>
          <div style={{ textAlign: "center" }}>
            {loading && itemLoading === "applyForm" ? (
              <div className="button_standard">
                {dict?.["Mengirim"]?.[language]}...
              </div>
            ) : (
              <button className="button_standard" type="submit">
                {dict?.["Daftar Jadi Surveyor"]?.[language]}
              </button>
            )}
          </div>
        </form>
      </main>
    </Modal>
  );

  const modal_read_content = (
    <main className="read_content" id="read_content">
      <section className="main_container" style={{ marginBottom: "100px" }}>
        {loading && itemLoading === "getDocForm" ? (
          <p>{dict?.["Memuat instruksi survei"]?.[language]}...</p>
        ) : !geo_layer_wo_geojson?.blog?._id ? (
          <section>
            {dict?.["Dokumen belum dibuat"]?.[language]}
            <div style={{ textAlign: "center" }}>
              <button
                onClick={handleFalseModalRead}
                className="button_standard"
              >
                {dict?.["Tutup"]?.[language]}
              </button>
            </div>
          </section>
        ) : (
          <div>
            <BlogRead blog={geo_layer_wo_geojson.blog} />
            <div style={{ textAlign: "center" }}>
              <button
                onClick={handleFalseModalRead}
                className="button_standard"
              >
                {dict?.["Mengerti"]?.[language]}
              </button>
            </div>
          </div>
        )}
      </section>
    </main>
  );

  return (
    <main>
      {modal_read_content}
      {modalLoginContent}
      {modalEditNameContent}
      {modalEditCityContent}
      {modalEditPhoneContent}
      {modalApplyPaidSurveyContent}

      <main className="main_container">
        <Title status={status} step={1} />
        {content}
      </main>

      <Helmet>
        <title>
          {geo_layer_wo_geojson?.name
            ? geo_layer_wo_geojson?.name
            : "MAPID FORM"}
        </title>
        <meta
          name="description"
          content={
            geo_layer_wo_geojson?.name
              ? geo_layer_wo_geojson?.name
              : "MAPID FORM"
          }
        />
      </Helmet>
      <style>{`.nav_bottom{ display:none;}`}</style>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  form: state.form,
});

export default connect(mapStateToProps, {
  get_feature,
  getFieldsPrivate,
  getDocForm,
  applyForm,
  updateFullname,
  updateCity,
  updatePhone,
  set_value_properties,
})(Step1);
